import { useOrganization } from "@api/organization.api";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { StateAwareNavigate } from "@components/routes/StateAwareNavigate";
import { useScope } from "@state/scopeContext.lib";
import { FC } from "react";

interface OrganizationRedirectProps {
    path: string;
}

export const OrganizationRedirect: FC<OrganizationRedirectProps> = ({
    path,
}) => {
    const { data: organization, isFetching } = useOrganization();
    const { changeActiveOrganization } = useScope();

    if (isFetching) {
        return <PageCoverLoader />;
    }

    if (!organization) {
        return <StateAwareNavigate to="/" replace />;
    }

    changeActiveOrganization(organization);
    return <StateAwareNavigate to={path} replace />;
};
